import {
  OPEN_INTERACTIVITY_MODAL_DYNAMIC,
  OPEN_INTERACTIVITY_MODAL_STATIC,
  CLOSE_INTERACTIVITY_MODAL,
  OPEN_RELATED,
  START_LOADING_MODAL,
  END_LOADING_MODAL,
  ERROR_MODAL
} from "../type";

const initState = {
  isModalOpen: false,
  dynamicContent: {},
  staticContent: {},
  loading: false,
  error: false
};

export default function(state = initState, action) {
  const { type, payload } = action;

  switch (type) {
    case START_LOADING_MODAL:
      return {
        ...state,
        loading: true,
        isModalOpen: true
      };
    case END_LOADING_MODAL:
      return {
        ...state,
        loading: false
      };
    case OPEN_INTERACTIVITY_MODAL_DYNAMIC:
      return {
        ...state,
        dynamicContent: payload.formattedData, //INFO ENDPOINT
        staticContent: payload.props,
        loading: false
      };
    case ERROR_MODAL:
      return {
        ...state,
        loading: false,
        error: true
      };
    case OPEN_INTERACTIVITY_MODAL_STATIC:
      return {
        ...state,
        staticContent: payload,
        loading: false
      };
    case OPEN_RELATED:
      return {
        ...state,
        dynamicContent: payload,
        loading: false
      };
    case CLOSE_INTERACTIVITY_MODAL:
      return initState;
    default:
      return state;
  }
}
